"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactRedux = require("react-redux");

var _reactTransitionGroup = require("react-transition-group");

var _MapButton = _interopRequireDefault(require("../components/MapButton"));

var _mapActions = require("../actions/mapActions");

var _map = _interopRequireDefault(require("../config/map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MapControl = function MapControl() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var menuOpen = (0, _reactRedux.useSelector)(function (state) {
    return !!state.menuReducer.currentMenu;
  });
  var currentView = (0, _reactRedux.useSelector)(function (state) {
    return state.mapViewReducer.mapView;
  });
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: menuOpen,
    appear: menuOpen,
    timeout: 300,
    classNames: 'map-control'
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-buttons'
  }, /*#__PURE__*/_react.default.createElement(_MapButton.default, {
    disabled: currentView.zoom === _map.default.maxZoom,
    onClick: function onClick() {
      return dispatch((0, _mapActions.zoomIn)());
    },
    title: 'Map Zoom In'
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'plus'],
    color: 'white'
  })), /*#__PURE__*/_react.default.createElement(_MapButton.default, {
    disabled: currentView.zoom === _map.default.minZoom,
    onClick: function onClick() {
      return dispatch((0, _mapActions.zoomOut)());
    },
    title: 'Map Zoom Out'
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'minus'],
    color: 'white'
  })), /*#__PURE__*/_react.default.createElement(_MapButton.default, {
    onClick: function onClick() {
      return dispatch((0, _mapActions.resetView)());
    },
    title: 'Map Overview'
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'expand'],
    color: 'white'
  })), /*#__PURE__*/_react.default.createElement(_MapButton.default, {
    onClick: function onClick() {
      return dispatch((0, _mapActions.goToCurrentLocation)());
    },
    title: 'Show My Location'
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'location-arrow'],
    color: 'white'
  }))));
};

var _default = MapControl;
exports.default = _default;